import { SaraAvatar } from './sara-avatar';

interface MessageBubbleProps {
  role: 'assistant' | 'candidate';
  content: string;
}

export function MessageBubble({ role, content }: MessageBubbleProps): React.ReactNode {
  const isAssistant = role === 'assistant';

  return (
    <div className={`flex ${isAssistant ? 'items-end gap-2 justify-start' : 'justify-end'}`}>
      {isAssistant && <SaraAvatar size="md" className="shrink-0" />}
      <div
        className={`max-w-[85%] rounded-2xl px-4 py-3 text-sm leading-relaxed whitespace-pre-wrap ${
          isAssistant
            ? 'rounded-bl-md bg-card shadow-sm border border-border text-foreground'
            : 'rounded-br-md bg-primary text-primary-foreground'
        }`}
      >
        {content}
      </div>
    </div>
  );
}
